/**
 * Table formatting helpers shared by OperationalExcellenceHub and the Top
 * Customers pages -- same "age since date" / "short date-time" rendering
 * rules for a Salesforce-case table, one implementation.
 *
 * NEUTRAL_SURFACE/DEEP_GREEN are inlined here rather than imported: neither
 * file has a shared color-token module today, and adding one just for two
 * hex values would be a bigger change than this extraction calls for.
 */

const NEUTRAL_SURFACE = '#F8F9FA';
const DEEP_GREEN = '#1A2E22';

export const formatTicketAge = (date) => {
  if (!date) return '—';
  const ms = Date.now() - new Date(date).getTime();
  if (Number.isNaN(ms) || ms < 0) return '—';
  const minutes = Math.floor(ms / 60000);
  if (minutes < 60) return `${Math.max(1, minutes)}m`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h`;
  return `${Math.floor(hours / 24)}d`;
};

export const formatSfTableDate = (date) => {
  if (!date) return '—';
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    year: '2-digit',
    hour: 'numeric',
    minute: '2-digit'
  });
};

export const tableHeaderCellSx = {
  bgcolor: NEUTRAL_SURFACE,
  color: DEEP_GREEN,
  fontWeight: 600,
  fontSize: '0.75rem',
  borderBottom: '2px solid rgba(26,46,34,0.12)'
};
